.container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  height: 100%;
  min-height: 600px;
}

.headerBar {
  width: 100%;
  height: 5px;
  background-color: #007bff; // Bootstrap primary blue
  margin-bottom: 20px;
}

.contentContainer {
  padding: 20px 20px 5px 20px;
  margin: 0px 0px 5px 0px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.footerBar {
  width: 100%;
  height: 5px;
  background-color: #007bff; // Bootstrap primary blue
  margin-top: 20px;
}

.stickyBottomBar {
  position: sticky;
  bottom: 0;
  padding: 1rem;
  border-top: 1px solid #dee2e6;
  background-color: #f8f9fa;
  margin-top: auto;
  z-index: 9999;
}

// Cell color classes for heat map visualization
.cellUnqualified {
  background-color: #f8f9fa !important; // Bootstrap light gray
  color: #6c757d !important; // Muted text
}

.cellLevelOne {
  background: linear-gradient(to right, #cce5ff 20%, white 20%) !important;
}
.cellLevelTwo {
  background: linear-gradient(to right, #99cbff 20%, white 20%) !important;
}
.cellLevelThree {
  background: linear-gradient(to right, #66b0ff 20%, white 20%) !important;
}
.cellLevelFour {
  background: linear-gradient(to right, #3398ff 20%, white 20%) !important;
}
.cellLevelFive {
  background: linear-gradient(to right, #007bff 20%, white 20%) !important;
}

// batch button
.batchButton {
  width: 20px;
  height: 20px;
  font-size: 0.75rem;
  font-weight: 500;
}

.batchButton:hover {
  color: #fff;
  background-color: #0d6efd;
  border-color: #0d6efd;
}

// Batch operations popup
.batchOperations {
  position: absolute;
  right: 0;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 150px;
  background-color: white;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  padding: 12px;
  z-index: 1000;
  margin-top: 5px;
}

.gridContainer {
  display: grid;
  /* First column: agent name (140px), then penalty column (80px if shown), then state columns */
  grid-template-columns: 140px repeat(var(--num-states), minmax(60px, 1fr));
  grid-auto-flow: row;
  gap: 4px;

  // make the grid scrollable
  max-height: calc(100vh - 250px);
  overflow: auto;

  // padding to account for the sticky headers
  padding-top: 2px;

  // ensures proper stacking context for fixed elements
  position: relative;

  // fixed grid position for cells
  grid-template-rows: 45px;
  grid-auto-rows: 34px;
}

.cornerCell {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 3;
  background-color: white;
  box-shadow: 2px 2px 5px rgba(0,0,0,0.1);
}

.headerCell {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: white;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}

.headerCellHighlighted {
  // background-color: rgba(255, 0, 0, 0.1);
  background-color: #ffebee !important;
}

.firstColumn {
  position: sticky;
  left: 0;
  z-index: 1;
  background-color: white;
  box-shadow: 2px 0 5px rgba(0,0,0,0.1);
}

.penaltyColumn {
  position: sticky;
  left: 144px; // 140px (first column) + 4px (gap)
  z-index: 1;
  background-color: white !important;
  box-shadow: 2px 0 5px rgba(0,0,0,0.1);
  min-width: 80px;
  max-width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.penaltyColumnNone {
  background-color: #f8f9fa !important; // Light grey, fully opaque
}

.penaltyColumnWarning {
  background-color: #fff3cd !important; // Warning yellow, fully opaque
}

.penaltyHeaderCell {
  position: sticky;
  top: 0;
  left: 144px; // 140px (first column) + 4px (gap)
  z-index: 3; // Higher than regular headers to overlap
  background-color: white !important;
  box-shadow: 2px 2px 5px rgba(0,0,0,0.1);
  min-width: 80px;
  max-width: 80px;
}

.gridCell {
  padding: 0px 0px 0px 0px;
  border-radius: 2px;
  text-align: center;
  // min-width: 100px;
  width: 100%;
  min-width: 0px;
  max-width: 60px;
  position: relative; /* to contain the batch button */
  max-height: 30px;
}

.gridCell > div {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  flex-wrap: nowrap !important;
  height: 100%;
}

.gridCell button,
.gridCell span {
  flex-shrink: 1 !important;
  min-width: 0 !important;
  font-size: 12px !important; /* Make text smaller if needed */
  padding: 1px 2px !important; /* Reduce padding */
}



/*
 * agent name should not overflow
 */
.agent-name {
  white-space: nowrap !important;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-grow: 1;
  min-width: 20px;
  cursor: pointer;
}

.agent-name:hover {
  overflow: visible;
  white-space: normal;
  position: relative;
  z-index: 10;
  background-color: white;
  padding: 2px 4px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15); /* Optional: makes it stand out */
}
